import type { LevelData, MeasurementGameData } from '../types';

export function getMeasurementLevels(gameData?: MeasurementGameData | null): LevelData[] {
	return (gameData?.questions ?? []).flatMap((question, questionIndex) => {
		if (!question?.game || !Array.isArray(question.answers)) return [];

		const { game } = question;
		const correctAnswer = question.answers.find((answer) => answer?.is_correct)?.answer_display;
		if (!correctAnswer) return [];

		return [
			{
				id: question.id,
				questionIndex,
				name: game.name,
				difficulty: game.difficulty,
				numberOfSteps: game.number_of_steps,
				questionDisplay: question.question_display,
				correctAnswer,
				messages: game.messages,
				hint: question.hint,
				platforms: game.platforms,
				coins: game.coins,
				hearts: game.hearts,
				hazards: game.hazards,
			},
		];
	});
}
